import React from 'react';
import { useMutation } from 'react-query';

import { deleteSystemBanner } from '../../../../api/systemBanner';
import useModal from '../../../../context/ModalContext';
import useAlarm from '../../../../context/AlarmContext';
import FormLoader from '../../../../components/FormLoader';

const DeleteModal = ({ id, refetch }) => {
  const { setAlarm } = useAlarm();
  const { closeModal } = useModal();

  const { mutate: deleteBannerMutation, isLoading } = useMutation(
    () => deleteSystemBanner(id),
    {
      onSuccess: () => {
        refetch();
        setAlarm({ type: 'success', message: 'System banner deleted successfully' });
        closeModal();
      },
      onError: (error) => {
        setAlarm({ type: 'error', message: error.message });
        closeModal();
      },
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    deleteBannerMutation();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="flex justify-between">
          <strong>Are you sure you want to delete this banner?</strong>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={closeModal}
              className="font-semibold p-4 rounded-lg bg-gray text-black mr-2"
            >
              No
            </button>
            <button
              type="submit"
              className="font-semibold p-4 rounded-lg bg-red text-white"
            >
              Yes
            </button>
          </div>
        </div>
      </form>
      {isLoading && <FormLoader />}
    </>
  );
};

export default DeleteModal;

